<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-container class="animated fadeIn">
      <b-card-title> Liftmanagement trajecten </b-card-title>
      <b-button-toolbar class="mb-3">
        <b-input-group prepend="Nieuw management traject voor">
          <relatie-select v-model="relatie" />

          <b-input-group-append>
            <b-button
              :disabled="!relatie"
              icon="fa fa-save"
              variant="success"
              @click="
                () =>
                  createTraject('/management', {
                    omschrijving: '',
                    relatieid: relatie.id,
                    taken: [],
                  }).then((response) => gotoTraject(response.data.traject))
              "
            >
              Starten
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-nav 
          tabs 
          class="ml-3"
        >
          <b-nav-item
            v-for="fase in fasen"
            :key="fase.status"
            :to="{ name: 'LiftManagement', params: { status: fase.status } }"
          >
            {{ fase.label }}
            <b-badge 
              v-if="aantallen[fase.status] != null" 
              pill 
              variant="secondary" 
              class="ml-1"
            >
              {{ aantallen[fase.status] }}
            </b-badge>
          </b-nav-item>
        </b-nav>
        <b-input-group class="ml-3">
          <b-input 
            v-model="filter" 
            type="search" 
            placeholder="Zoeken..." 
          />
        </b-input-group>
      </b-button-toolbar>

      <b-table
        ref="table"
        :fields="['relatie', 'naam', 'status', 'activiteiten', 'notitie']"
        :items="trajecten"
        :filter="filter"
        striped
        small
        bordered
        hover
        select-mode="single"
        @row-clicked="gotoTraject($event)"
      >
        <template #cell(relatie)="row">
          {{
            row.item.relatie
              ? row.item.relatie.naam
              : "-geen relatie geselecteerd-"
          }}
        </template>

        <template #cell(datum)="row">
          {{ moment(row.item.datum).format("L") }}
        </template>

        <template #cell(activiteiten)="row">
          {{ row.item.activiteiten ? row.item.activiteiten.join(", ") : "" }}
        </template>

        <template #cell(notitie)="row">
          {{ row.item.omschrijving }}
        </template>
      </b-table>

      <router-view 
        @update="onUpdateManagement" 
        @delete="onDeleteManagement"
      />
    </b-container>
  </b-overlay>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { verkoopMixin } from "@/mixins/verkoopMixin";
import RelatieSelect from "../../../components/RelatieSelect.vue";

// Statussen zoals gedefinieerd in Traject.vue, gegroepeerd voor de tabs.
const LOPENDE_STATUSSEN = ["inschrijving", "gunning", "uitvoering", "oplevering"];

const FASEN = [
  { status: "lopend", label: "Lopend" },
  { status: "inschrijving", label: "Inschrijving" },
  { status: "gunning", label: "Gunning" },
  { status: "uitvoering", label: "Uitvoering" },
  { status: "oplevering", label: "Oplevering" },
  { status: "afgesloten", label: "Afgesloten" },
];

export default {
  name: "LiftManagementView",
  components: {
    RelatieSelect,
  },
  mixins: [serviceMixin, verkoopMixin],
  props: {
    status: {
      type: String,
      default: "lopend",
    },
  },
  data() {
    return {
      trajecten: [],
      relatie: null,
      filter: null,
      fasen: FASEN,
      aantallen: {},
    };
  },
  computed: {
    tabRoute: function () {
      return this.$route.matched[1].name;
    },
    // 'lopend' is geen echte status maar de default groep op de API (alles behalve afgesloten).
    apiStatus: function () {
      return this.status && this.status.toLowerCase() !== "lopend"
        ? this.status.toUpperCase()
        : null;
    },
  },
  watch: {
    status: {
      immediate: true,
      handler: function () {
        this.getTrajecten();
      },
    },
  },
  mounted() {
    this.getStatussen();
  },
  methods: {
    getTrajecten() {
      var vm = this;
      this.busy = true;
      var params = this.apiStatus ? { status: this.apiStatus } : {};
      this.get("/management", { params: params })
        .then((response) => (vm.trajecten = response.data.trajecten))
        .finally(() => (vm.busy = false));
    },
    getStatussen() {
      var vm = this;
      this.get("/management/statussen").then((response) => {
        var aantallen = {};
        response.data.statussen.forEach((s) => {
          aantallen[s.status.toLowerCase()] = s.aantal;
        });
        aantallen.lopend = LOPENDE_STATUSSEN.reduce(
          (totaal, key) => totaal + (aantallen[key] || 0),
          0
        );
        vm.aantallen = aantallen;
      });
    },
    gotoTraject: function (traject) {
      this.$router.push({
        name: "Traject",
        params: { status: this.status, id: traject.id },
      });
      this.getTrajecten();
    },
    onUpdateManagement(traject) {
      console.log("onUpdateManagement", traject);
      this.getTrajecten();
      this.getStatussen();
    },
    onDeleteManagement(traject) {
      console.log("onDeleteManagement", traject);
      var indx = this.trajecten.map((o) => o.id).indexOf(traject.id);
      this.trajecten.splice(indx, 1);
      this.$refs.table.refresh();
      this.getStatussen();
    },
  },
};
</script>
